(function(){
    'use strict';

    angular
       .module('appback')
       .factory('StockService', StockService);

       StockService.$inject = ['$http'];

    function StockService($http){


       var service= {
        getStockFromMaterial:getStockFromMaterial,
        setModificacionStock:setModificacionStock,
        setNuevoLote:setNuevoLote,
        getStockFromMaterialAndLote:getStockFromMaterialAndLote,
        getStockFromHojaId:getStockFromHojaId,
        getAllStocksByLote:getAllStocksByLote,
        liberarStockMaterial: liberarStockMaterial,
        //liberarTodoStock:liberarTodoStock,
        rechazarStockMaterial:rechazarStockMaterial,
        //rechazarTodoStock:rechazarTodoStock,
        subirSage:subirSage
       };

       return service;
        function getStockFromMaterial(material_id,callback) {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/stock/getstockfrommaterialid', { params : {material_id:material_id}  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                console.log('failed', data)
                
                return false;
            }

        }
        function setModificacionStock(operacion, cantidadGestion, stockToModify, callback) {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var postParams = $.param(
                {
                    stocktomodify:JSON.stringify(stockToModify),
                    operacion:operacion,
                    cantidadGestion:cantidadGestion
                }
            );
            $http.post('/backend/stock/setstocktomodify',  postParams  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }

        function subirSage(stock_id, callback) {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var postParams = $.param(
                {
                    stock_id:stock_id
                }
            );
            $http.post('/backend/stock/subirsage',  postParams  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }

        function setNuevoLote(nuevoLote, callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var postParams = $.param(
                {
                    nuevoLote:JSON.stringify(nuevoLote)
                }
            );
            $http.post('/backend/stock/setnuevolote',  postParams  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function liberarStockMaterial(id_stock, cantidad_liberar, hojafabricacionactiva,almacen_id, callback) {
            console.log('liberar stock service', id_stock);

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var postParams = $.param(
                {
                    id_stock:id_stock,
                    cantidad_liberar:cantidad_liberar,
                    hojafabricacion_id:hojafabricacionactiva.id,
                    almacen_id:almacen_id
                }
            );
            $http.post('/backend/hojafabricacion/liberarstockmaterial',  postParams  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }

        }

        function rechazarStockMaterial(id_stock, cantidad_liberar, hojafabricacionactiva, callback) {
            console.log('liberar stock service', id_stock);

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var postParams = $.param(
                {
                    id_stock:id_stock,
                    cantidad_liberar:cantidad_liberar,
                    hojafabricacion_id:hojafabricacionactiva.id,
                }
            );
            $http.post('/backend/hojafabricacion/rechazarstockmaterial',  postParams  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }

        }

        function getStockFromMaterialAndLote(hojafabricacionactiva,lote,cuarentena,callback) {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            //console.log('params from getStockFromMaterialAndLote', material_id, lote, cuarentena);
            $http.get('/backend/stock/getstockfrommaterialidandlote', { params : {material_id:hojafabricacionactiva.material_id,lote:lote,cuarentena:cuarentena,hojafabricacion_id:hojafabricacionactiva.id}  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                console.log('failed', data)
                
                return false;
            }
        }

        function getStockFromHojaId(hojafabricacionactiva_id,callback) {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/stock/getstockbyhojaid', { params : {hojafabricacion_id:hojafabricacionactiva_id}  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                console.log('failed', data)
                
                return false;
            }
        }

        function getAllStocksByLote(material_id, lote, callback) {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/stock/getallstocksbylote', { params : {material_id:material_id,lote:lote}  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                console.log('failed', data)
                
                return false;
            }
        }
    }
})();